import {Indicator, Root} from '@radix-ui/react-checkbox';
import clsx from 'clsx';
import React from 'react';

type Props = Omit<React.ComponentPropsWithRef<typeof Root>, 'children'> & {
  name: string;
  size?: 'sm' | 'md' | 'lg';
} & (
    | {
        label: React.ReactNode;
        description?: React.ReactNode;
      }
    | {
        // name: string;
        label?: never;
        description?: never;
      }
  );
export function Checkbox({
  name,
  size,
  label,
  description,
  className,
  ...props
}: Props): React.JSX.Element {
  const commentsId = `comments-${name}`;

  return (
    <div className={clsx(className, 'flex gap-3')}>
      <div className="flex h-6 shrink-0 items-center">
        <div
          className={clsx(
            'grid grid-cols-1',
            size === 'sm' && 'size-3',
            (size === 'md' || !size) && 'size-3.5',
            size === 'lg' && 'size-6'
          )}
        >
          <Root
            {...props}
            id={name}
            name={name}
            aria-describedby={description ? commentsId : undefined}
            className="group col-start-1 row-start-1 appearance-none rounded-sm border border-slate7 bg-slate1 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue9 disabled:bg-slate4 radix-state-checked:border-blue9 radix-state-checked:bg-blue9 disabled:radix-state-checked:border-slate7 disabled:radix-state-checked:bg-slate4 radix-state-indeterminate:border-blue9 radix-state-indeterminate:bg-blue9 disabled:radix-state-indeterminate:border-slate7 disabled:radix-state-indeterminate:bg-slate4 forced-colors:appearance-auto"
          >
            <Indicator>
              <svg
                fill="none"
                viewBox="0 0 14 14"
                className={clsx(
                  'pointer-events-none col-start-1 row-start-1 self-center justify-self-center stroke-white group-radix-disabled:stroke-slate9',
                  size === 'sm' && 'size-2.5',
                  (size === 'md' || !size) && 'size-3',
                  size === 'lg' && 'size-5'
                )}
              >
                <path
                  d="M3 7H11"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="opacity-0 group-radix-state-indeterminate:opacity-100"
                />
                <path
                  d="M3 8L6 11L11 3.5"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="opacity-0 group-radix-state-checked:opacity-100"
                />
              </svg>
            </Indicator>
          </Root>
        </div>
      </div>

      {label && (
        <div className="text-sm/6">
          <label
            htmlFor={name}
            className={clsx('text-slate12', description && 'font-medium')}
          >
            {label}
          </label>

          {description && (
            <p id={commentsId} className="text-slate11">
              {description}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
